export class BasketSessionModel {
    public userId: string;
    public sessionId: string;
    public financeSubmissionDate: number | null = null;
}